<template>
<div class="chapter">
<div class="inner_page">
<p class="largeheight">For Kate and John,<br/>who love their bath,<br/>and for Alberto,<br/>always immaculate</p>
<p class="center"><img alt="" src="OEBPS/images/005_Ashe_art_r1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?3136d66d